import * as z from "zod"

import { HasIdNameDisplay, HasStrIdName } from "~/@shared/api-types/id-name-display"

type ForJobHuntingStatuses = HasStrIdName & { display?: undefined }

type Item = string | number | Option | Partial<HasIdNameDisplay> | ForJobHuntingStatuses

const OPTION_SCHEMA = z.object({
  text: z.string(),
  value: z.string(),
  disabled: z.boolean().optional(),
})

export type Option = z.infer<typeof OPTION_SCHEMA>

const isOption = (it: unknown): it is Option => {
  return OPTION_SCHEMA.safeParse(it).success === true
}

type CreateOptionsParam = {
  /**
   * trueを指定するとdisplayの値(`"3年生"` / `"男"` など)がselectタグのvalueになる(basic_info.name_graduates_in.{year,sex}などが該当)
   *
   * falseを指定するとidの値がselectタグのvalueになる
   */
  isValueDisplay?: boolean
  isAddInitialOption?: boolean
  /** @default "選択してください" */
  initialOptionText?: "選択してください" | "未選択" | (string & {})
}

export const createOptions = (items: Item[], param: CreateOptionsParam = {}): Option[] => {
  const { isValueDisplay, isAddInitialOption, initialOptionText = "選択してください" } = param
  let newItems = items.map((item): Option => {
    if (typeof item === "string") {
      return { text: item, value: item }
    }

    if (typeof item === "number") {
      const numberText = `${item}`
      return { text: numberText, value: numberText }
    }

    if (isOption(item)) {
      return item
    }

    return {
      text: ("display" in item && item.display) || item.name || "",
      value: isValueDisplay ? ("display" in item && item.display) || item.name || "" : `${item.id}`,
    }
  })
  if (isAddInitialOption) {
    newItems = [{ text: initialOptionText, value: "", disabled: true }, ...newItems]
  }
  return newItems
}
